































import { Component, Vue } from 'vue-property-decorator';
import HeadLable from '@/components/HeadLable/index.vue';
import { addCompetition, queryCompetitionById, updateCompetition } from '@/api/competition.ts';
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addCompetition',
  components: {
    HeadLable
  }
})
export default class extends Vue {
  private title = '新建公告';
  private title1 = '';
  private actionType = 'add';
  private titleId = '';
  private titleId1 = '';
  private ruleForm = {
    id: '', // 添加 id 字段，用于编辑时标识赛事
    content: ''
  };

  private rules = {
    content: [
      {
        required: true,
        message: '请输入公告内容',
        trigger: 'blur'
      },
      {
        max: 255,
        message: '公告内容不能超过255个字符',
        trigger: 'blur'
      }
    ]
  };

  created() {
    this.titleId1 = this.$route.query.titleId;
    this.title1 = this.$route.query.title;
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改公告信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  cancel() {
    this.$router.push({ path: '/competition/noticeManage', query: { titleId: this.titleId1, title: this.title1 } })
  }

  private async init() {
    const params = {
      id: this.$route.query.id,
      type: 1
    };
    queryCompetitionById(params).then((res: any) => {
      if (res.data.code === 1) {
        this.ruleForm = {
          ...this.ruleForm,
          id: res.data.data.id, // 确保 id 被正确赋值
          content: res.data.data.content
        };
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }

  private submitForm(continueAdd: boolean = false) {
    (this.$refs.ruleForm as any).validate((valid: boolean) => {
      if (valid) {
        const params = {
          id: this.ruleForm.id, // 添加 id 字段
          content: this.ruleForm.content,
          type: 1,
          titleId: this.titleId
        };

        if (this.actionType === 'add') {
          addCompetition(params)
            .then((res: any) => {
              if (res.data.code === 1) {
                this.$message.success('公告新建成功！');
                if (!continueAdd) {
                  this.$router.push({ path: '/competition/noticeManage', query: { titleId: this.titleId1, title: this.title1 } });
                } else {
                  this.ruleForm = {
                    content: ''
                  };
                }
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              this.$message.error('请求出错了');
            });
        } else if (this.actionType === 'edit') {
          delete params.titleId
          updateCompetition(params)
            .then((res: any) => {
              if (res.data.code === 1) {
                this.$message.success('公告修改成功！');
                this.$router.push({ path: '/competition/noticeManage', query: { titleId: this.titleId1, title: this.title1 } });
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              this.$message.error('请求出错了');
            });
        }
      } else {
        this.$message.error('表单验证失败，请检查输入');
      }
    });
  }
}
